<template>
  <v-app class="layout-container">
    <!-- HEADER FIXO NO TOPO -->
    <v-app-bar
      flat
      height="88"
      color="transparent"
      class="fixed-header"
    >
      <div class="header-inner">
        <NuxtLink
          to="/"
          class="logo-overlay"
          aria-label="Ir para o início"
        >
          <span
            class="logo-mark"
            aria-hidden="true"
          >
            <img
              src="/img/logo.png"
              alt=""
            />
          </span>
          <span
            class="logo-wordmark"
            aria-hidden="true"
          >
            <img
              src="/img/logo.png"
              alt=""
            />
          </span>
          <span
            class="logo-subtitle"
            aria-hidden="true"
          >
            FUNDO DE APOIO AO REGISTRO CIVIL DE PESSOAS NATURAIS
          </span>
        </NuxtLink>

        <div class="header-spacer"></div>

        <div class="d-none d-lg-flex align-center menu-wrapper">
          <template
            v-for="(item, index) in menuItems"
            :key="index"
          >
            <v-menu
              v-if="item.submenu"
              offset-y
              content-class="funarpen-menu-content"
            >
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  class="menu-btn"
                  variant="text"
                >
                  {{ item.label }}
                  <v-icon end>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list class="funarpen-menu-list">
                <v-list-item
                  v-for="(subItem, subIndex) in item.submenu"
                  :key="subIndex"
                  link
                  @click="onMenuClick"
                  v-bind="subItem.external ? { href: subItem.link, target: '_blank', rel: 'noopener noreferrer' } : {}"
                  :to="!subItem.external ? subItem.link : null"
                >
                  <v-list-item-title>{{ subItem.label }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn
              v-else-if="item.external"
              class="menu-btn"
              :href="item.link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ item.label }}
            </v-btn>

            <v-btn
              v-else
              class="menu-btn"
              :to="item.link"
              exact
              @click="onMenuClick"
            >
              {{ item.label }}
            </v-btn>
          </template>
        </div>

        <div class="header-actions">
          <NotificationCenter :auto-open="true" />
        </div>

        <v-app-bar-nav-icon
          class="mobile-menu-btn d-lg-none"
          @click="drawer = !drawer"
        />
      </div>
    </v-app-bar>
    <!-- DRAWER MOBILE -->
    <v-navigation-drawer
      v-model="drawer"
      temporary
      app
      class="mobile-drawer"
    >
      <v-list
        nav
        dense
      >
        <template
          v-for="(item, index) in menuItems"
          :key="index"
        >
          <v-list-group
            v-if="item.submenu"
            v-model="item.open"
            prepend-icon="mdi-chevron-down"
          >
            <template #activator="{ props }">
              <v-list-item
                v-bind="props"
                style="cursor: pointer"
              >
                <v-list-item-title class="font-weight-bold">
                  {{ item.label }}
                </v-list-item-title>
              </v-list-item>
            </template>

            <template
              v-for="(subItem, subIndex) in item.submenu"
              :key="subIndex"
            >
              <v-list-item @click="onMenuClick">
                <template #default>
                  <router-link
                    v-if="!subItem.external"
                    :to="subItem.link"
                    class="drawer-link"
                  >
                    {{ subItem.label }}
                  </router-link>

                  <a
                    v-else
                    :href="subItem.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="drawer-link"
                  >
                    {{ subItem.label }}
                  </a>
                </template>
              </v-list-item>
            </template>
          </v-list-group>

          <v-list-item
            v-else-if="item.external"
            @click="onMenuClick"
          >
            <template #default>
              <a
                :href="item.link"
                target="_blank"
                rel="noopener noreferrer"
                class="drawer-link"
              >
                {{ item.label }}
              </a>
            </template>
          </v-list-item>

          <v-list-item
            v-else
            @click="onMenuClick"
          >
            <template #default>
              <router-link
                :to="item.link"
                class="drawer-link"
              >
                {{ item.label }}
              </router-link>
            </template>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- CONTEÚDO PRINCIPAL -->
    <v-main class="main-content">
      <div class="page-container">
        <NuxtPage />
      </div>
    </v-main>

    <!-- FOOTER -->
    <AppFooter />
  </v-app>
</template>

<script setup>
import { ref } from 'vue'
import { useRuntimeConfig } from '#imports'
import AppFooter from '~/components/AppFooter.vue'
import NotificationCenter from '~/components/Notificacoes.vue'

const config = useRuntimeConfig()
const version = config.public.appVersion

const drawer = ref(false)

const menuItems = ref([
  { label: 'Início', link: '/' },
  {
    label: 'Institucional',
    submenu: [
      { label: 'Sobre o FUNARPEN', link: '/funarpen/sobre' },
      { label: 'Conselho Diretor', link: '/funarpen/conselho-diretor' },
      { label: 'Conselho Fiscal', link: '/funarpen/conselho-fiscal' },
      { label: 'Organograma', link: '/funarpen/organograma' },
      { label: 'Regimento Interno', link: '/funarpen/regimento-interno' },
      { label: 'Atas das Assembleias', link: '/funarpen/atas-assembleias' },
    ],
    open: false,
  },
  {
    label: 'Serviços',
    submenu: [
      { label: 'Convênios', link: '/funarpen/convenios' },
      { label: 'Instruções Normativas', link: '/funarpen/instrucoes-normativas' },
      { label: 'Legislação', link: '/funarpen/publicacoes/leis' },
      { label: 'Valores dos Selos', link: '/funarpen/selos' },
      { label: 'Editais', link: '/funarpen/publicacoes/editais' },
      { label: 'Links Úteis', link: '/funarpen/links-importantes' },
    ],
    open: false,
  },
])

function onMenuClick() {
  drawer.value = false
}
</script>

<style scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.fixed-header {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: var(--funarpen-header-height) !important;
  border-bottom: 1px solid rgba(8, 47, 73, 0.1);
  background: rgba(248, 251, 253, 0.9) !important;
  box-shadow: 0 14px 42px rgba(8, 47, 73, 0.12) !important;
  backdrop-filter: blur(18px) saturate(160%);
  -webkit-backdrop-filter: blur(18px) saturate(160%);
}

.fixed-header :deep(.v-toolbar__content) {
  height: var(--funarpen-header-height) !important;
  width: 100%;
  padding: 0 !important;
}

.header-inner {
  display: flex;
  align-items: center;
  gap: clamp(10px, 1.6vw, 20px);
  width: 100%;
  height: 100%;
  padding: 0 clamp(10px, 1.15vw, 18px);
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.page-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  padding-top: var(--funarpen-header-height);
}

.logo-overlay {
  position: relative;
  display: block;
  flex: 0 0 auto;
  cursor: pointer;
  width: clamp(238px, 24vw, 286px);
  aspect-ratio: 913 / 273;
  text-decoration: none;
  transform: translateY(1px);
}

.logo-mark,
.logo-wordmark {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.logo-mark img,
.logo-wordmark img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  image-rendering: -webkit-optimize-contrast;
}

.logo-mark {
  clip-path: inset(0 70.5% 0 0);
}

.logo-wordmark {
  clip-path: inset(0 0 42% 27%);
}

.logo-subtitle {
  position: absolute;
  top: 59%;
  left: 30.1%;
  z-index: 1;
  color: #25506a;
  font-family: 'Arial Narrow', 'Roboto Condensed', Arial, sans-serif;
  font-size: clamp(6.4px, 0.62vw, 8px);
  font-weight: 700;
  letter-spacing: 0.08px;
  line-height: 1;
  white-space: nowrap;
  -webkit-font-smoothing: antialiased;
  text-rendering: geometricPrecision;
}

.header-spacer {
  flex: 1;
}

.header-actions {
  display: flex;
  align-items: center;
  margin-left: 4px;
}

.menu-wrapper {
  gap: 4px;
  margin-left: auto;
  padding: 6px;
  border: 1px solid rgba(8, 47, 73, 0.1);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.menu-btn {
  min-height: 38px;
  color: var(--funarpen-ink) !important;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  border-radius: 999px !important;
  padding: 0 14px;
}

.menu-btn:hover {
  background-color: rgba(11, 79, 108, 0.08);
  color: var(--funarpen-blue) !important;
}

.menu-btn.router-link-exact-active,
.menu-btn.v-btn--active {
  background-color: rgba(191, 152, 81, 0.18);
  color: var(--funarpen-navy) !important;
}

.mobile-menu-btn {
  color: var(--funarpen-blue) !important;
  border: 1px solid rgba(8, 47, 73, 0.12);
  background: rgba(255, 255, 255, 0.74);
}

.mobile-drawer {
  background: linear-gradient(180deg, rgba(248, 251, 253, 0.98), rgba(238, 246, 250, 0.98)) !important;
  color: var(--funarpen-ink);
}

.mobile-drawer :deep(.v-list-item) {
  border-radius: var(--funarpen-radius);
  margin: 2px 8px;
}

.drawer-link {
  display: block;
  width: 100%;
  padding: 10px 14px;
  text-decoration: none;
  color: var(--funarpen-ink);
  font-weight: 700;
}

.drawer-link:hover {
  color: var(--funarpen-blue);
  background-color: rgba(11, 79, 108, 0.08);
}

:global(.funarpen-menu-content) {
  border-radius: var(--funarpen-radius) !important;
  box-shadow: var(--funarpen-shadow) !important;
}

:global(.funarpen-menu-list) {
  padding: 8px !important;
  border: 1px solid rgba(8, 47, 73, 0.1);
  border-radius: var(--funarpen-radius) !important;
  background: rgba(255, 255, 255, 0.98) !important;
}

:global(.funarpen-menu-list .v-list-item) {
  border-radius: var(--funarpen-radius) !important;
  color: var(--funarpen-ink);
  font-weight: 600;
}

:global(.funarpen-menu-list .v-list-item:hover) {
  background: rgba(11, 79, 108, 0.08) !important;
}

@media (max-width: 1260px) {
  .logo-overlay {
    width: 246px;
  }

  .menu-btn {
    padding: 0 10px;
    font-size: 0.84rem;
  }
}

@media (max-width: 960px) {
  .header-inner {
    padding: 0 12px;
  }

  .logo-overlay {
    width: min(238px, 68vw);
  }

  .header-spacer {
    flex: 1;
  }

  .header-actions {
    margin-left: auto;
  }

  .mobile-menu-btn {
    width: 42px;
    height: 42px;
  }
}

@media (max-width: 430px) {
  .logo-overlay {
    width: min(212px, 62vw);
  }
}
</style>
